import React, { useState } from 'react';
import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import { tokens } from "../theme";
import { useDispatch } from 'react-redux';
import { updateQuotationTypes } from '../features/cart/cartSlice'; // Update path as needed

const AddQuotationTypeModal = ({ open, handleClose }) => {
  const [newType, setNewType] = useState('');
  const [error, setError] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (!newType.trim()) {
      setError('Quotation type cannot be empty');
      return;
    }
    
    dispatch(updateQuotationTypes(newType.trim()));
    setNewType('');
    setError('');
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="add-quotation-type-modal"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: colors.primary[400],
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" component="h2" mb={3} color={colors.grey[100]}>
          Add New Quotation Type
        </Typography>
        
        <TextField
          fullWidth
          label="New Quotation Type"
          value={newType}
          onChange={(e) => setNewType(e.target.value)}
          error={!!error}
          helperText={error}
          sx={{
            mb: 3,
            '& label': { color: colors.grey[300] },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: colors.grey[300] },
              '&:hover fieldset': { borderColor: colors.greenAccent[500] },
              '& input': { color: colors.grey[100] }
            }
          }}
        />
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            onClick={handleClose}
            sx={{
              backgroundColor: colors.grey[500],
              color: colors.grey[100],
              '&:hover': { backgroundColor: colors.grey[600] }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            sx={{
              backgroundColor: colors.greenAccent[700],
              color: colors.grey[100],
              '&:hover': { backgroundColor: colors.greenAccent[600] }
            }}
          >
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddQuotationTypeModal;